
import { Device } from '../../base/Device';

/**
 * @author yeyuchao
 * @description 天空森林城市
 */
let waterRippler = null;
let initCanvasSlideshow = null;
let device = new Device();
const screenWidth = window.screen.width;
const screenHeight = window.screen.height;
let hasSwitch = false;
export default {
  data() {
    return {
    };
  },
  mounted() {

  },
  created() {

  },
  methods:{

  },
  beforeDestroy(){

  },
  destroyed(){
  }
};



// WEBPACK FOOTER //
// ./src/pages/skyDetail/skyDetail.js